
// English translations
export const en = {
  // Navigation
  navigation: {
    services: "Services",
    howWeWork: "How We Work",
    technologies: "Technologies",
    caseStudies: "Case Studies",
    contact: "Contact",
  },
  // Hero section
  hero: {
    title: "AI-Powered Solutions for Modern Business",
    subtitle: "We build intelligent applications that drive efficiency, innovation, and growth",
    ctaButton: "Get Started",
    secondaryButton: "Learn More",
  },
  // Services section
  services: {
    title: "Our Services",
    subtitle: "Comprehensive suite of services designed to help businesses harness the power of AI and data",
    description: "We offer a comprehensive suite of AI solutions tailored to your business needs",
    learnMore: "Learn more"
  },
  // Industries section
  industries: {
    title: "Industries We Serve",
    manufacturing: "Manufacturing",
    infrastructure: "Infrastructure",
    warehouses: "Warehouses",
    supplyChain: "Supply Chain",
    categories: {
      industrialMachinery: "Industrial Machinery",
      threeDPrinting: "3D Printing",
      roboticSolutions: "Robotic Solutions",
      energy: "Energy",
      dataCenters: "Data Centers",
      governmentFacilities: "Government Facilities",
      distributionCenters: "Distribution Centers",
      coldStorage: "Cold Storage",
      microFulfillment: "Micro-fulfillment",
      retail: "Retail",
      foodAndAgriculture: "Food & Agriculture",
      logisticsAndTransportation: "Logistics & Transportation",
    },
  },
  // Process section
  process: {
    title: "Our Process",
  },
  // Technologies section
  technologies: {
    title: "Technologies",
  },
  // Tools section
  tools: {
    title: "Tools We Use",
  },
  // Case studies section
  caseStudies: {
    title: "Case Studies",
    viewAllButton: "View All Case Studies",
  },
  // Contact section
  contact: {
    title: "Contact Us",
    name: "Name",
    email: "Email",
    message: "Message",
    submitButton: "Send Message",
  },
  // Footer
  footer: {
    company: "Company",
    about: "About",
    resources: "Resources",
    legal: "Legal",
    privacyPolicy: "Privacy Policy",
    terms: "Terms",
    cookiePolicy: "Cookie Policy",
    copyright: "© 2025 KLEXU. All rights reserved.",
  },
};
